<template>
	<el-dialog v-model="props.showDialog" :close-on-click-modal="state.clickModel" :draggable="true" @close="closeExcute"
		@open="openedExcute" :title="$t('mainLayout.report.exportReport')" width="800px" append-to-body>
		<el-steps :active="state.currentStep" align-center>
			<el-step :title="$t('mainLayout.report.baseInfo')" />
			<el-step :title="$t('mainLayout.report.devicePoint')" />
		</el-steps>
		<div v-if="state.currentStep == 0" class="param-container">
			<div class="property-col1">
				<label class="name">{{ $t("mainLayout.report.reportName") }}:</label>
				<el-input class="value" maxlength="20" v-model="state.title" />
			</div>
			<div class="property-col">
				<label class="name">{{ $t("common.startTime") }}:</label>
				<el-date-picker class="value" type="datetime" :placeholder="$t('common.selectStartTimePlaceholder')"
					:teleported="false" v-model="state.startTime" format="YYYY-MM-DD HH:mm:ss"
					value-format="YYYY-MM-DD HH:mm:ss" />
			</div>
			<div class="property-col">
				<label class="name">{{ $t("common.endTime") }}:</label>
				<el-date-picker class="value" type="datetime" :placeholder="$t('common.selectEndTimePlaceholder')"
					:teleported="false" v-model="state.endTime" format="YYYY-MM-DD HH:mm:ss"
					value-format="YYYY-MM-DD HH:mm:ss" />
			</div>
		</div>
		<div v-if="state.currentStep == 1" class="selector">
			<div class="l1">
				<div class="header">
					<div class="spliter"></div>
					<label style="float: left">{{ $t("mainLayout.report.deviceList") }}</label>
					<el-checkbox v-model="state.deviceCheckedAll" :indeterminate="deviceIndeterminate" class="checkAll"
						:label="$t('common.checkAll')" @change="handleCheckAllDeviceChanged">
					</el-checkbox>
				</div>
				<div class="border">
					<div class="row" v-for="d in state.devices" @click="handleClickDeviceRow(d)"
						:class="{ active: d.isActive }">
						<el-checkbox class="checkbox" @click.stop v-model="d.isSelect" :indeterminate="d.Indeterminate"
							@change="handleCheckDeviceChanged(d)" />
						<span class="text">{{ d.Name }}</span>
					</div>
				</div>
			</div>
			<div class="l1" style="margin-left: 1%">
				<div class="header">
					<div class="spliter"></div>
					<label style="float: left">{{ $t("mainLayout.report.pointList") }}</label>
					<el-checkbox class="checkAll" v-model="state.pointCheckedAll" :indeterminate="pointIndeterminate"
						:label="$t('common.checkAll')" @change="handleCheckAllPointsChanged"></el-checkbox>
				</div>
				<div class="border">
					<div class="row" v-for="p in state.selectDevice?.points" :class="{ active: p.isActive }">
						<el-checkbox class="checkbox" @click.stop v-model="p.isSelect" @change="handleCheckPointChanged(p)"
							:indeterminate="p.Indeterminate" />
						<span class="text">{{ p.Name }}</span>
					</div>
				</div>
			</div>
		</div>
		<div v-if="state.currentStep == 2" class="graph-container">
			<div :id="state.graphId" class="graph-container"></div>
		</div>
		<template #footer>
			<span class="dialog-footer">
				<el-button v-if="state.currentStep == 1" @click="state.currentStep = 0">{{
					$t("mainLayout.report.previousStep") }}</el-button>
				<el-button type="primary" v-if="state.currentStep == 0" @click="state.currentStep = 1">{{
					$t("mainLayout.report.nextStep") }}</el-button>
				<el-button type="primary" v-if="state.currentStep == 1" @click="sureExcute">{{ $t("common.export")
				}}</el-button>
				<el-button @click="cancelExcute">{{ $t("common.cancel") }}</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script setup>
import { nextTick, reactive, computed } from "vue";
import axios from "@common/js/axios";
import store from "@common/js/store";
import dayjs from "dayjs";
import { alertSuccessMsg, fullScreenLoading, getDeepClone, guid, i18nGlobal } from "@common/js/utils";
import { PluginMode, ScaleType } from "@core/graphs/webcharts/Dh-webchart-models";
import { SpectralGraph } from "@core/graphs/js/Dh-graph-spectral";
import { TrendGraph } from "@core/graphs/js/Dh-graph-trend";
import { WaveGraph } from "@core/graphs/js/Dh-graph-wave";
import $ from "jquery";
import { EnumQueryDataType } from "@components/js/utils/model";
import { Canvg } from "canvg";
import html2canvas from "html2canvas";
import { CustomGraph } from "@core/graphs/js/Dh-graph-custom";

const props = defineProps({
	showDialog: {
		type: Boolean,
		default: false,
	},
});
let reportEntity = null;
const state = reactive({
	currentStep: 0,
	devices: new Array(),
	selectDevice: null,
	deviceCheckedAll: false,
	pointCheckedAll: false,
	clickModel: true,
	datas: [],
	startTime: null,
	endTime: null,
	enitiyId: null,
	title: i18nGlobal("mainLayout.report.monitorReport"),
	graphId: guid(),
});

const emit = defineEmits(["close"]);

const closeExcute = () => {
	emit("close");
};

const openedExcute = async () => {
	await getHistoryData();
	state.currentStep = 0;
	state.clickModel = true;
	state.graphId = guid();
	reportEntity = {};
	await getTree(store.state.currentDep);
};

const sureExcute = () => {
	state.currentStep = 2;
	state.clickModel = false;
	exportReport();
	//emit("close");
};

const cancelExcute = () => {
	if (state.clickModel == false) return;
	emit("close");
};

const getHistoryData = async () => {
	const node = store.state.currentDep;
	let res = await axios.get(`report/dataAnalysis/${node.Id}/type/1`);
	if (res.Result) {
		state.datas = res.Result.ReportPoints;
		state.title = res.Result.Name;
		state.startTime = res.Result.StartTime;
		state.endTime = res.Result.EndTime;
		state.enitiyId = res.Result.Id;
	} else {
		state.datas = [];
		state.title = i18nGlobal("mainLayout.report.monitorReport");
		state.startTime = dayjs().add(-1, "hour").format("YYYY-MM-DD HH:mm:ss.SSS");
		state.endTime = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
	}
};

const deviceIndeterminate = computed(() => {
	let checked = state.devices.filter((r) => r.isSelect);
	state.deviceCheckedAll = checked.length == state.devices.length && checked.length > 0;
	return checked.length < state.devices.length && checked.length > 0;
});

const pointIndeterminate = computed(() => {
	if (state.selectDevice == null) return false;
	let checked = state.selectDevice.points.filter((r) => r.isSelect);
	state.pointCheckedAll = checked.length == state.selectDevice.points.length && checked.length > 0;
	return checked.length < state.selectDevice.points.length && checked.length > 0;
});

const handleCheckAllDeviceChanged = async (value) => {
	for (let device of state.devices) {
		await getPoints(device);
		device.isSelect = value;
		for (let point of device.points) {
			point.isSelect = value;
			for (let eigen of point.Eigens) {
				eigen.isSelect = value;
			}
		}
		updateIndeterminate(device);
	}
};

const updateIndeterminate = (device) => {
	let checkedPoints = device.points.filter((r) => r.isSelect);
	device.Indeterminate = checkedPoints.length > 0 && checkedPoints.length < device.points.length;
};

const handleClickDeviceRow = async (device) => {
	if (state.selectDevice) state.selectDevice.isActive = false;
	await getPoints(device);
	updateIndeterminate(device);
	device.isActive = true;
	state.selectDevice = device;
};

const handleCheckDeviceChanged = async (device) => {
	let status = device.isSelect;
	await handleClickDeviceRow(device);
	device.isSelect = status;
	for (let point of state.selectDevice.points) {
		point.isSelect = status;
	}
	updateIndeterminate(device);
};

const handleCheckAllPointsChanged = (value) => {
	for (let point of state.selectDevice.points) {
		point.isSelect = value;
	}
	state.selectDevice.isSelect = true;
	updateIndeterminate(state.selectDevice);
};

const handleCheckPointChanged = (p) => {
	state.selectDevice.isSelect = state.selectDevice.points.filter((r) => r.isSelect).length > 0;
	updateIndeterminate(state.selectDevice);
};

const getTree = async (currentNode) => {
	let res = await axios.get(`Tree/${currentNode.Path}/type/3,4`);
	if (res.IsSuccess) {
		state.devices = [];
		for (let node of res.Result.orderBy((p) => p.Path)) {
			node.isSelect = state.datas.find((r) => r.DeviceId == node.Id) != null;
			node.isActive = false;
			node.Indeterminate = false;
			state.devices.push(node);
		}
		if (state.devices.length > 0) {
			let checkDevices = state.devices.filter((r) => r.isSelect);
			if (checkDevices.length > 0) {
				handleClickDeviceRow(checkDevices[0]);
			} else {
				handleClickDeviceRow(state.devices[0]);
			}
		}
	}
};

const getPoints = async (device) => {
	if (device.points != null) return;
	let res = await axios.get(`Component/points/${device.Path}`, {});
	if (res.IsSuccess) {
		device.points = res.Result;
		for (let point of device.points) {
			point.Eigens = new Array();
			let tempPoint = state.datas.find((r) => r.PointId == point.Id);
			for (let eigen of point.EigenTypes) {
				point.Eigens.push({
					Id: eigen.Key,
					Name: eigen.Value,
				});
			}
			point.isSelect = tempPoint != null;
			point.isActive = false;
		}
		device.isSelect = device.points.filter((r) => r.isSelect).length > 0;
		device.Indeterminate = false;
	}
};

const exportReport = async () => {
	nextTick(async () => {
		const graphContainer = $(`#${state.graphId}`);
		await createTrendGraph(graphContainer);
		reportEntity.PointDatas = [];
		for (let device of state.devices.filter((r) => r.isSelect)) {
			const alarmInfos = await getFaultAlarmInfos(device.Id);
			for (let alarmInfo of alarmInfos) {
				const dataInfo = await getFaultAlarmDatas(alarmInfo);
				if (dataInfo) {
					const faultData = {
						Name: alarmInfo.Path,
						GraphtDatas: [],
					};
					faultData.GraphtDatas.push(await createWaveGraph(graphContainer, dataInfo.WaveData));
					faultData.GraphtDatas.push(await createFFtGraph(graphContainer, dataInfo.FFTData));
					faultData.GraphtDatas.push(await createOrderGraph(graphContainer, dataInfo.OrderData));
					//await createAmpGraph(dataInfo.AmpData);
					reportEntity.PointDatas.push(faultData);
				}
			}
		}
		reportEntity.ReportTemplate = {
			Id: state.enitiyId,
			StartTime: state.startTime,
			EndTime: state.endTime,
			Name: state.title,
			PlotType: 1,
			DeviceId: store.state.currentDep.Id,
			ReportPoints: getCheckPoints(),
		};
		axios({
			method: "post",
			url: "report/dataAnalysis/export",
			data: reportEntity,
		}).then(() => {
			alertSuccessMsg(i18nGlobal("common.exportSuccess"));
		});
		saveParam();
	});
};

const saveParam = () => {
	const condition = reportEntity.ReportTemplate;
	axios({
		method: "put",
		url: "report/dataAnalysis",
		data: condition,
	})
		.then((res) => { })
		.finally(() => {
			state.clickModel = true;
			emit("close");
		});
};

const getCheckPoints = () => {
	let datas = getCheckDevicePoints();
	const result = [];
	for (let data of datas.values()) {
		result.push(...data);
	}
	return result;
};

const getCheckDevicePoints = () => {
	let datas = new Map();
	for (let device of state.devices.filter((r) => r.isSelect)) {
		datas.set(device.Id, []);
		if (device.points) {
			for (let point of device.points.filter((r) => r.isSelect)) {
				var eigens = new Array();
				for (let eigen of point.Eigens) {
					eigens.push({
						Id: eigen.Id,
						Name: eigen.Name,
					});
				}
				datas.get(device.Id).push({
					PointId: point.Id,
					DeviceId: device.Id,
					Name: point.Name,
					ValueList: eigens,
				});
			}
		} else {
			let temp = state.datas.filter((r) => r.DeviceId == device.Id);
			for (let p of temp) {
				datas.get(device.Id).push(getDeepClone(p));
			}
		}
	}
	return datas;
};

const createTrendGraph = async (graphContainer) => {
	const graph = new TrendGraph();
	initGraph(graph, i18nGlobal('component.title.trendGraph'));
	reportEntity.SubmachineDatas = [];
	const devicePoints = getCheckDevicePoints();
	for (let nodeId of devicePoints.keys()) {
		const node = state.devices.find((r) => r.Id == nodeId);
		const points = devicePoints.get(nodeId);
		const datas = await getTrendHistoryData(points);
		if (datas) {
			graph.SetData(datas, state.startTime, state.endTime);
		} else {
			graph.ClearData();
		}
		const imagePath = await captureGraphImages(graphContainer);
		reportEntity.SubmachineDatas.push({ Name: node.Name, Path: imagePath, Id: node.Id });
	}
	graph.Clear();
	graphContainer.empty();
};

const getTrendHistoryData = async (points) => {
	const condition = {
		StartTime: state.startTime,
		EndTime: state.endTime,
		DataType: EnumQueryDataType.Eigen,
		Points: [],
	};
	points
		.filter((p) => p.ValueList.length > 0)
		.map((point) => {
			condition.Points.push({
				PointId: point.PointId,
				EigenTypes: [point.ValueList[0].Id],
			});
		});
	const loading = fullScreenLoading(i18nGlobal("common.query"));
	const res = await axios({
		method: "post",
		url: `DataManage/datas-v2`,
		data: condition,
	}).finally(() => {
		loading.close();
	});
	if (res.IsSuccess && res.Result?.length > 0) return res.Result;
	return null;
};

const createWaveGraph = async (graphContainer, datas) => {
	const graph = new CustomGraph();
	initGraph(graph, i18nGlobal('component.title.waveGraph'));
	if (datas?.length > 0) {
		graph.SetData(datas);
	}
	const imagePath = await captureGraphImages(graphContainer);
	graph.Clear();
	graphContainer.empty();
	return {
		Name: i18nGlobal("mainLayout.report.timeDomain") + "：",
		Path: imagePath,
	};
};

const createFFtGraph = async (graphContainer, datas) => {
	const graph = new SpectralGraph();
	initGraph(graph, i18nGlobal('component.title.fftGraph'));
	if (datas?.length > 0) {
		graph.SetData(datas);
	}
	const imagePath = await captureGraphImages(graphContainer);
	graph.Clear();
	graphContainer.empty();
	return {
		Name: i18nGlobal("mainLayout.report.fftTitle"),
		Path: imagePath,
	};
};

const createOrderGraph = async (graphContainer, datas) => {
	const graph = new SpectralGraph();
	initGraph(graph, i18nGlobal('component.title.orderAlgorithm'));
	if (datas?.length > 0) {
		graph.SetData(datas);
	}
	const imagePath = await captureGraphImages(graphContainer);
	graph.Clear();
	graphContainer.empty();
	return {
		Name: i18nGlobal('component.title.orderAlgorithm') + "：",
		Path: imagePath,
	};
};

const createAmpGraph = async () => { };

const captureGraphImages = async (graphContainer) => {
	let svgMaps = new Array();
	for (let svg of graphContainer.find("svg")) {
		const svgHtml = svg.outerHTML.trim();
		const canvas = document.createElement("canvas");
		const ctx = canvas.getContext("2d");
		let v = await Canvg.from(ctx, svgHtml, {
			ignoreAnimation: false,
			log: true,
		});
		v.start();
		$(svg).after($(canvas));
		$(svg).addClass("hide");
		svgMaps.push({
			svg: $(svg),
			canvas: $(canvas),
		});
	}
	return new Promise(function (resolve, reject) {
		const opts = {
			scale: 1,
			height: graphContainer.height(),
			windowHeight: graphContainer.width(),
		};
		html2canvas(graphContainer[0], opts).then(async function (canvas) {
			let myImage = canvas.toDataURL("image/png");
			svgMaps.map((item) => {
				item.canvas.remove();
				item.svg.removeClass("hide");
			});
			svgMaps = [];
			const res = await axios({
				method: "post",
				url: `workstate/getImagePath`,
				data: {
					ImageSource: myImage.replace(/^data:image\/(png|jpg|jpeg);base64,/, ""),
				},
			});
			if (res?.Result != null) {
				resolve(res.Result);
			} else {
				reject(new Error(i18nGlobal("mainLayout.report.FailedToSaveMap")));
			}
		});
	});
};

const getFaultAlarmInfos = async (id) => {
	const res = await axios({
		method: "get",
		url: `alarm/GetEquipmentLatestFaultAlarmInfo/${id}`,
	});
	if (res.Result) {
		return res.Result;
	}
	return [];
};

const getFaultAlarmDatas = async (alarmInfo) => {
	const condition = {
		Time: alarmInfo.AlarmStartTime,
		PointIds: [],
	};
	alarmInfo.FaultModelAlarmEvents.map((item) => {
		condition.PointIds.push(item.PointId);
	});
	const loading = fullScreenLoading(i18nGlobal("common.inQuery"));
	const res = await axios({
		method: "post",
		url: `report/dataAnalysis/getDatas`,
		data: condition,
	}).finally(() => {
		loading.close();
	});
	return res.Result;
};

const initGraph = (graph, title) => {
	const option = {
		Id: state.graphId,
		Axis: {
			Title: title,
			AxisScaleType: ScaleType.Auto,
			ShowDot: true,
			Theme: 1,
		},
	};
	const plugins = [
		{ Type: PluginMode.YAxisZoomOut },
		{ Type: PluginMode.YAxisZoomIn },
		{ Type: PluginMode.XAxisZoomOut },
		{ Type: PluginMode.XAxisZoomIn },
		{ Type: PluginMode.SingleCursor },
		{ Type: PluginMode.Statistics },
	];
	graph.Init(option, plugins);
	const array = [];
	plugins
		.filter((r) => r.Type >= 100)
		.map((item) => {
			array.push(item.Type);
		});
	graph.GetPluginManager().OpenPlugin(array);
	graph.GetPluginManager().OpenPlugin([PluginMode.SingleCursor]);
	graph.OnSizeChanged();
};
</script>

<style scoped lang="less">
:deep(.el-step.is-center .el-step__line) {
	left: 0 !important;
	right: -50% !important;
}

:deep(.el-step__head.is-process),
:deep(.el-step__head.is-finish) {
	color: var(--phm-theme-background);
	border-color: var(--phm-primary-color);

	.el-step__icon {
		background-color: var(--phm-primary-color);
	}
}

:deep(.el-step__head.is-wait) {
	color: var(--phm-theme-mainText);
	border-color: var(--phm-theme-tip);

	.el-step__icon {
		background-color: var(--phm-theme-border);
	}
}

:deep(.is-finish .el-step__line) {
	background-color: var(--phm-primary-color) !important;
}

:deep(.is-wait .el-step__line) {
	background-color: var(--phm-theme-tip) !important;
}

:deep(.is-process .el-step__line) {
	background-color: var(--phm-primary-color) !important;
}

:deep(.el-step:last-of-type .el-step__line) {
	display: block;
	right: 0% !important;
}

:deep(.el-step__title.is-process) {
	color: var(--phm-primary-color) !important;
}

.param-container {
	margin-top: 10px;
	display: flow-root;

	.property-col {
		width: 365px;
		margin-right: 15px;

		.name {
			margin-bottom: 5px;
			display: block;
		}
	}

	.property-col1 {
		width: 98%;
		margin-bottom: 10px;

		.name {
			margin-bottom: 5px;
			display: block;
			color: var(--phm-theme-mainText);
		}
	}
}

.selector {
	float: left;
	width: 100%;
	margin-bottom: 20px;

	.l1 {
		width: 48%;
		text-align: center;
		padding: 2px;
		overflow: auto;
		float: left;

		.checkAll {
			float: right;
			margin-right: 3px;
			margin-top: 4px;
		}

		.border {
			border: 1px solid var(--phm-theme-border);
			height: 530px;
			padding-top: 5px;

			.row {
				width: 94%;
				float: left;
				padding-left: 20px;
				height: 40px;
				line-height: 40px;
				margin-left: 3%;
				border-radius: 5px;

				label {
					float: left;
				}

				// &:hover {
				//     background-color: var(--phm-primary-light-color);
				// }
			}
		}

		.text {
			float: left;
			line-height: 40px;
			margin-left: 10px;
		}

		.checkbox {
			margin-top: 4px;
		}
	}
}

.graph-container {
	float: left;
	width: 100%;
	height: 450px;
	margin-bottom: 20px;
}
</style>
